import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans, useTranslation } from '@zurich/common/hooks';
import { styled } from '../../utils';
import { Button } from '../Button';
import { Dialog } from '../Dialog';
import { Typography } from '../Typography';
export var AlertType;
(function (AlertType) {
    AlertType["INFO"] = "info";
    AlertType["DEFAULT"] = "default";
    AlertType["WARN"] = "warn";
})(AlertType || (AlertType = {}));
export function AlertDialog({ title, description, open, cancelAction = true, continueAction = true, alternativeAction = false, cancelText, continueText, alternativeText, onContinue, onCancel = () => { }, onAlternative = () => { }, onExited = () => { }, variant = AlertType.DEFAULT, children, maxWidth, primaryCancel, loading = false, fullWidth = false, }) {
    const { t } = useTranslation();
    const dialogActions = primaryCancel ? (_jsxs(DivStyled, { children: [alternativeAction && (_jsx(Button, { color: "primary", onClick: onAlternative, children: alternativeText })), continueAction && (_jsx(Button, { color: "primary", onClick: onContinue, loading: loading, children: continueText ?? t('common:button_label.reload') })), cancelAction && (_jsx(Button, { color: "primary", variant: "contained", onClick: onCancel, disabled: loading, children: cancelText ?? t('common:button_label.cancel') }))] })) : (_jsxs(DivStyled, { children: [alternativeAction && (_jsx(Button, { color: "primary", onClick: onAlternative, children: alternativeText })), cancelAction && (_jsx(Button, { color: "primary", onClick: onCancel, disabled: loading, children: cancelText ?? t('common:button_label.cancel') })), continueAction && (_jsx(Button, { color: "primary", variant: "contained", onClick: onContinue, loading: loading, children: continueText ?? t('common:button_label.reload') }))] }));
    return (_jsx(Dialog, { showInfoIcon: variant === AlertType.INFO, showWarningIcon: variant === AlertType.WARN, open: open, onClose: onCancel, showCloseIcon: true, dialogTitle: title ?? t('common:continue'), dialogActions: dialogActions, TransitionProps: { onExited }, maxWidth: maxWidth, fullWidth: fullWidth, children: _jsx(_Fragment, { children: children ? (children) : (_jsx(Typography, { variant: "body1", children: _jsx(Trans, { components: {
                        em: _jsx("em", {}),
                        a: _jsx("a", {}),
                        b: _jsx("b", {}),
                        br: _jsx("br", {}),
                        span: _jsx("span", {}),
                    }, children: description }) })) }) }));
}
const DivStyled = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
    gap: theme.spacing(1),
    '& > button': {
        width: 'fit-content',
    },
    [theme.breakpoints.up('sm')]: {
        justifyContent: 'space-between',
        flexDirection: 'row',
    },
}));
